import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';

import { initializeSentry } from 'common/components/Sentry/Sentry';
import { ConversationAssistantApp } from 'common/components/CopyMagic';

const renderConversationAssistant = (container: HTMLElement) => {
  if (!container.dataset.props) return;

  const props = JSON.parse(container.dataset.props);
  const { productArea = null } = props;

  initializeSentry({
    tags: { team: 'CreatorTools', component: 'copy_magic_conversation_assistant' },
  });

  container.dataset.amaRendered = 'true';

  const { contextToken = '', floatingButton = true, fullscreen = false } = props;

  ReactDOM.render(
    <Sentry.ErrorBoundary>
      <ConversationAssistantApp
        productArea={productArea}
        floatingButton={floatingButton}
        fullscreen={fullscreen}
        contextToken={contextToken}
      />
    </Sentry.ErrorBoundary>,
    container,
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('react-copy-magic-conversation-assistant-container');
  if (!container) return;
  if (container.dataset.amaRendered) return;

  renderConversationAssistant(container);
});

document.addEventListener('turbo:load', () => {
  const container = document.getElementById('react-copy-magic-conversation-assistant-container');
  if (!container) return;
  if (container.dataset.amaRendered) return;

  renderConversationAssistant(container);
});
